module.exports = __webpack_public_path__ + "static/img/chamber.966fa76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/chamber.png
// module id = T7et
// module chunks = 12